const navLinks = [
  {
    path: "/dashboard",
    icon: "ri-apps-2-line",
    display: "Dashboard",
  },
  {
    path: "/assets",
    icon: "ri-steering-2-fill",
    display: "Assets",
  },
  {
    path: "/bookings",
    icon: "ri-taxi-line",
    display: "Booking",
  },
  {
    path: "/sell-car",
    icon: "ri-shopping-bag-line",
    display: "Sell Cars",
  },
  {
    path: "/buy-car",
    icon: "ri-shopping-cart-line",
    display: "Buy Cars",
  },
  {
    path: "/services",
    icon: "ri-scissors-2-line",
    display: "Services",
  },
  {
    path: "/calender",
    icon: "ri-calendar-2-line",
    display: "Calender",
  },
  {
    path: "/message",
    icon: "ri-message-2-line",
    display: "Messages",
  },
];

export default navLinks;
